function responseStatus(err: unknown): number | undefined {
  const status = (err as { response?: { status?: unknown } } | null)?.response?.status
  return typeof status === 'number' ? status : undefined
}

/**
 * The server looked at the file and said no (too large, wrong type). Every
 * other failure - no response, a proxy deadline, a busy server - may not
 * even have reached it, or may have stored the file before the answer was
 * lost, so it is worth sending again with the same upload key.
 */
export function isRefusal(err: unknown): boolean {
  const status = responseStatus(err)
  return status !== undefined && status >= 400 && status < 500 && status !== 408 && status !== 429
}
